exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label.cms-label{color:#223b55;font-size:12px;letter-spacing:.5px;margin-bottom:5px;padding:0}.cms-form-field input{margin-top:0;font-size:17px}.cms-form-field .cms-field-hint{font-size:13px;color:#787e84;margin-top:5px}.cms-form-field+.cms-form-field{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44a8a879","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cms/Input.vue
// module id = a6Zp
// module chunks = 0 1